/**
 * 申请售后相关API
 */

import request from '@/utils/request'



/**
 * 获取国家列表
 * @returns {AxiosPromise}
 */
export function getCountryList() {
  return request({
    url: '/country/list',
    method: 'get',
    ApiBase: true,
    needToken: false,
    loading: false,
  })
}

/**
 * 获取币种
 * @returns {AxiosPromise}
 */
export function getCurrency() {
  return request({
    url: '/currency/list',
    method: 'get',
    ApiBase: true,
    needToken: false,
    loading: false,
  })
}

/**
 * 获取FAQ
 * @returns {AxiosPromise}
 */
export function getFAQ() {
  return request({
    url: '/faq',
    method: 'get',
    ApiBase: false,
    needToken: false,
    loading: false,
  })
}

/**
 * 绑定支付查询
 * @returns {AxiosPromise}
 */
export function bindList() {
  return request({
    url: '/merch/pay/list',
    method: 'get',
    ApiBase: false,
    needToken: true,
    loading: true,
  })
}

/**
 * 网站基础配置
 * @returns {AxiosPromise}
 */
export function webSite() {
  return request({
    url: '/web/config/list',
    method: 'get',
    ApiBase: false,
    needToken: false,
    loading: false,
  })
}